<template>
  <div>
    <div class="ligneRouge"></div>

    <v-row
      style="position: relative; top: 0"
      v-if="appStore.modele.optionRegionale.estActifMessageUrgent"
    >
      <v-col cols="12">
        <v-alert type="error" class="mb-0">
          <div v-html="appStore.modele.optionRegionale.messageUrgent"></div>
        </v-alert>
      </v-col>
    </v-row>

    <div class="boutonInscrire" style="position: relative">
      <v-img class="imageBandeau" alt="Bandeau.png"></v-img>

      <div class="top-right">
        <v-row>
          <v-col sm="4" cols="1"></v-col>
          <v-col class="mt-7" sm="8" cols="11">
            <v-row class="py-1">
              <label style="width: 100%" class="bandeauTitre">
                {{ $t("accueil.CoursEte") }}
              </label>
              <label style="width: 100%" class="bandeauTitre"
                >{{ $t("accueil.EnLigne") }}
              </label>
            </v-row>
            <v-row class="paddingBandeau">
              <label class="texteBandeau" style="width: 100%">
                {{ $t("accueil.InitiativeCSS") }}
              </label>
              <label class="texteBandeau" style="width: 100%">
                {{ `${appStore.nomRegion}` }}
              </label>
            </v-row>

            <!--Btn inscription-->
            <v-row class="py-1" style="justify-content: flex-end">
              <v-btn
                class="rounded boutonPrincipal"
                elevation="8"
                v-on:click.stop="InscriptionDialog()"
                :loading="inscriptionStore.chargement"
              >
                <div class="d-grid">
                  <span class="d-grid" v-html="texteBtnInscription" />
                </div>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
    <InscriptionDialog ref="inscriptionDialog" />

    <v-img
      style="height: 100%; padding-top: 50px; padding-bottom: 50px"
      class="imageFond"
      alt="Fond550.png"
    >
      <div class="container-boite">
        <v-row v-if="inscriptionTermine">
          <BoiteResultatsEleve />
        </v-row>
        <v-row>
          <BoiteOffreRegional />
          <v-expansion-panels
            flat
            style="padding: 24px; padding-bottom: 0"
            v-model="getEtatPanneau"
            id="listeCSSParticipantes"
          >
            <PanneauExtension :titre="$tc('accueil.panneau.titre')">
              <CSSParticipantesTable />
            </PanneauExtension>
          </v-expansion-panels>
        </v-row>
        <v-row>
          <v-col md="7" cols="12">
            <div style="display: flex; flex-flow: column; height: 100%">
              <v-col cols="12" style="flex: 0 1 auto">
                <BoiteInfoGenerales />
              </v-col>
              <v-col cols="12" style="flex: 0 1 auto">
                <BoiteEpreuvesUniquesMEQ />
              </v-col>
              <v-col cols="12" style="flex: 1 1 auto">
                <BoitePrecisions />
              </v-col>
            </div>
          </v-col>
          <v-col md="5" cols="12">
            <BoiteInscriptionLigne />
          </v-col>
        </v-row>
      </div>
    </v-img>

    <BoiteNousJoindre />
    <div class="petiteLigneRouge"></div>
  </div>
</template>

<script>
import useAppStore from '@/store/appStore';
import useInscriptionStore from '@/store/inscriptionStore';
// import { InscriptionCSS } from '@/outils/Enum';
import CSQCOutilsCoursEte from '@/outils/CSQCOutilsCoursEte';
import BoiteOffreRegional from './BoiteOffreRegional.vue';
import BoiteInfoGenerales from './BoiteInfoGenerales.vue';
import BoitePrecisions from './BoitePrecisions.vue';
import BoiteInscriptionLigne from './BoiteInscriptionLigne.vue';
import BoiteResultatsEleve from './BoiteResultatsEleves.vue';
import BoiteNousJoindre from './BoiteNousJoindre.vue';
import BoiteEpreuvesUniquesMEQ from './BoiteEpreuvesUniquesMEQ.vue';
import InscriptionDialog from './InscriptionDialog.vue';
import PanneauExtension from '../custom/PanneauExtension.vue';
import CSSParticipantesTable from './CSSParticipantesTable.vue';

export default {
  name: 'EleveInscriptionPrincipal',
  components: {
    BoiteOffreRegional,
    BoiteInfoGenerales,
    BoitePrecisions,
    BoiteInscriptionLigne,
    BoiteNousJoindre,
    BoiteResultatsEleve,
    InscriptionDialog,
    BoiteEpreuvesUniquesMEQ,
    PanneauExtension,
    CSSParticipantesTable,
  },
  setup() {
    const appStore = useAppStore();
    const inscriptionStore = useInscriptionStore();

    return { appStore, inscriptionStore };
  },
  data() {
    return {
      titreDateInscription: '',
      texteBtnInscription: '',
      peutSincrire: false,
      inscriptionTermine: false,
    };
  },
  async created() {
    await this.inscriptionStore.definirOptionCSS();

    // Obtention et modification du titre de la date d'inscription selon l'année courante
    const anneeCourante = new Date().getFullYear();
    let titreDateInscription = this.$t('accueil.Des13Juin');
    titreDateInscription = titreDateInscription.replace(
      '{anneeCourante}',
      anneeCourante,
    );
    this.titreDateInscription = titreDateInscription;

    await this.definirAffichageBtnInscription();
  },
  computed: {
    getEtatPanneau: {
      get() {
        return this.inscriptionStore.panneauOuvertCssParticipante;
      },
      set(val) {
        this.inscriptionStore.definirPanneauCSSParticipante(val);
      },
    },
    peutSincrireBlocs() {
      const optionsRegionale = this.appStore.modele.optionRegionale;
      return (
        (optionsRegionale.inscriptionOuverte &&
          !optionsRegionale.inscriptionTermine) ||
        (optionsRegionale.inscriptionExamenOuverte &&
          !optionsRegionale.inscriptionExamenTermine) || // Si pendant les inscription d'examen
        (!optionsRegionale.inscriptionOuverte &&
          optionsRegionale.inscriptionTermine &&
          !optionsRegionale.inscriptionExamenOuverte &&
          !optionsRegionale.inscriptionExamenTermine)
      ); // Si pas commencer mais pas terminé ( entre le moment que inscription normal sont fermé et inscription examen pas commencé)
    },
  },
  methods: {
    InscriptionDialog() {
      // False = redirige vers l'horaire d'inscription
      if (this.peutSincrire === false) {
        window.location.href = '#HoraireInscriptions';
      } else if (this.peutSincrire) { // True = ouvre le dialog d'inscription
        this.$refs.inscriptionDialog.ouvrirDialog();
      }
      // Si Null = Ne fait rien
    },

    async definirAffichageBtnInscription() {
      // Reset valeurs
      this.peutSincrire = false;
      this.inscriptionTermine = false;

      await this.inscriptionStore.definirCoursEnLigne({
        cssId: -1,
        scolariseMaison: false,
      });
      // Si aucun blocs est enCours (ouvert)
      if (this.inscriptionStore.listeCoursLigne.length === 0) {
        const lstBlocs =
          CSQCOutilsCoursEte.ObtenirEtTrierBlocsFutursOuverture(
            this.inscriptionStore.listeBlocOrganisme,
          );
        // Si un des blocs va prochainement ouvrir
        if (lstBlocs != null && lstBlocs.length > 0) {
          this.texteBtnInscription = `<span>${this.$tc('accueil.cliquerIciConsulterHoraire')}</span> `;
          this.peutSincrire = false;
        } else {
          // Si tout les blocs sont terminés (donc Inscription terminée)
          this.texteBtnInscription = this.$tc('accueil.InscriptionTerminee');
          this.peutSincrire = null;
          this.inscriptionTermine = true;
        }
      } else if (this.peutSincrireBlocs) {
        // Si un des blocs est ouverts (peut s'inscrire)
        this.texteBtnInscription = this.$tc('accueil.SInscrire');
        this.peutSincrire = true;
      }
    },
  },
};
</script>

<style scoped>
.v-btn__content {
  font-size: 30px !important;
  line-height: 38px !important;
}
</style>
